import { RSAA } from 'redux-api-middleware';

import {
  GET_SERVICES_REQUESTED,
  GET_SERVICES_FAILURE,
  GET_SERVICES_SUCCESS,
  GET_SERVICESUBTYPES_REQUESTED,
  GET_SERVICESUBTYPES_FAILURE,
  GET_SERVICESUBTYPES_SUCCESS,
  GET_PROVIDERS_REQUESTED,
  GET_PROVIDERS_FAILURE,
  GET_PROVIDERS_SUCCESS,
  GET_VERSIONS_REQUESTED,
  GET_VERSIONS_SUCCESS,
  GET_VERSIONS_FAILURE,
  GET_REGIONS_REQUESTED,
  GET_REGIONS_FAILURE,
  GET_REGIONS_SUCCESS,
  GET_PLANS_REQUESTED,
  GET_PLANS_SUCCESS,
  GET_PLANS_FAILURE,
  GET_FLAVORS_REQUESTED,
  GET_FLAVORS_SUCCESS,
  GET_FLAVORS_FAILURE,
  GET_ADDONS_REQUESTED,
  GET_ADDONS_SUCCESS,
  GET_ADDONS_FAILURE,
  GET_CATALOG_CONFIG_REQUEST,
  GET_CATALOG_CONFIG_SUCCESS,
  GET_CATALOG_CONFIG_FAILURE,
} from '../actions';

export const getServicesActionSet = () => ({
  [RSAA]: {
    types: [GET_SERVICES_REQUESTED, GET_SERVICES_SUCCESS, GET_SERVICES_FAILURE],
    method: 'GET',
    endpoint: '/services/',
  },
});

export const getServices = () => (dispatch) => dispatch(getServicesActionSet());

export const getServiceSubtypesActionSet = () => ({
  [RSAA]: {
    types: [
      GET_SERVICESUBTYPES_REQUESTED,
      GET_SERVICESUBTYPES_SUCCESS,
      GET_SERVICESUBTYPES_FAILURE,
    ],
    method: 'GET',
    endpoint: '/servicesubtypes/',
  },
});

export const getServiceSubtypes = () => (dispatch) => dispatch(getServiceSubtypesActionSet());

export const getProvidersActionSet = () => ({
  [RSAA]: {
    types: [GET_PROVIDERS_REQUESTED, GET_PROVIDERS_SUCCESS, GET_PROVIDERS_FAILURE],
    method: 'GET',
    endpoint: '/cloudproviders/',
  },
});

export const getProviders = () => (dispatch) => dispatch(getProvidersActionSet());

export const getVersionsActionSet = () => ({
  [RSAA]: {
    types: [GET_VERSIONS_REQUESTED, GET_VERSIONS_SUCCESS, GET_VERSIONS_FAILURE],
    method: 'GET',
    endpoint: '/versions/',
  },
});

export const getVersions = () => (dispatch) => dispatch(getVersionsActionSet());

export const getRegionsActionSet = () => ({
  [RSAA]: {
    types: [GET_REGIONS_REQUESTED, GET_REGIONS_SUCCESS, GET_REGIONS_FAILURE],
    method: 'GET',
    endpoint: '/regions/',
  },
});

export const getRegions = () => (dispatch) => dispatch(getRegionsActionSet());

export const getPlansActionSet = () => ({
  [RSAA]: {
    types: [GET_PLANS_REQUESTED, GET_PLANS_SUCCESS, GET_PLANS_FAILURE],
    method: 'GET',
    endpoint: '/plans/',
  },
});

export const getPlans = () => (dispatch) => dispatch(getPlansActionSet());

export const getFlavorsActionSet = () => ({
  [RSAA]: {
    types: [GET_FLAVORS_REQUESTED, GET_FLAVORS_SUCCESS, GET_FLAVORS_FAILURE],
    method: 'GET',
    endpoint: '/flavors/',
  },
});

export const getFlavors = () => (dispatch) => dispatch(getFlavorsActionSet());

export const getAddonsActionSet = () => ({
  [RSAA]: {
    types: [GET_ADDONS_REQUESTED, GET_ADDONS_SUCCESS, GET_ADDONS_FAILURE],
    method: 'GET',
    endpoint: '/addons/',
  },
});

export const getAddons = () => (dispatch) => dispatch(getAddonsActionSet());

const getConfigurationActionSet = (serviceSubtype) => ({
  [RSAA]: {
    types: [GET_CATALOG_CONFIG_REQUEST, GET_CATALOG_CONFIG_SUCCESS, GET_CATALOG_CONFIG_FAILURE],
    method: 'GET',
    endpoint: `/configurations/?serviceSubtype=${serviceSubtype.toLowerCase()}`,
  },
});

export const getConfiguration = (serviceSubtype) => (dispatch) =>
  dispatch(getConfigurationActionSet(serviceSubtype));
